import React, { Component } from 'react'

import urlFor from 'shared/tools/url-helper'
import { getShowcaseLink } from 'client/bookmate/helpers/showcase-helpers'

import ShowcaseLayout from 'client/bookmate/blocks/showcase-layout'
import Spacer from 'client/shared/blocks/spacer'
import { Loader } from 'client/shared/blocks/loader'
import InfiniteScroll from 'client/shared/blocks/infinite-scroll'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { Dispatch } from 'shared/types/redux'
import {
  ShowcaseSection,
  Navigation,
  ShowcaseAttributes,
  TabProps,
} from 'client/shared/types/showcase'

type Props = {
  app: AppState
  dispatch: Dispatch
  attributes: ShowcaseAttributes
  sections: {
    items: ShowcaseSection[]
    loading: boolean
  }
  navigation: {
    items: Navigation[]
    loading: boolean
  }
  libraryLang: string
  handleSearchFocus: () => void
  tabs: TabProps[]
  loadSectionsFrom: number | null | undefined
  load: (page: number) => void
  userId: number
  sectionSlug?: string
  isKids?: boolean
}

class ShowcaseContent extends Component<Props> {
  getShowcasePath = (section: ShowcaseSection): string => {
    const {
      attributes: { contentType, slug },
      app,
      isKids,
    } = this.props
    if (!(section.all_url && section.slug)) return ''

    const link = isKids ? 'decije-knjige' : getShowcaseLink(contentType, slug)

    return urlFor.showcaseSection(link, section.slug, app.storedQuery)
  }

  render(): JSX.Element {
    const { sections, navigation } = this.props

    return (
      <div className="showcase-content">
        {(sections.loading || navigation.loading) &&
        sections.items.length === 0 ? (
          <>
            <Spacer size="top-page" />
            <Loader color="gray" kind="big" centered />
          </>
        ) : (
          this.renderShowcase()
        )}
      </div>
    )
  }

  renderShowcase(): JSX.Element | null {
    const {
      sections,
      navigation,
      attributes: { language, slug, contentType },
      app,
      dispatch,
      libraryLang,
      loadSectionsFrom,
      load,
      userId,
      sectionSlug,
      isKids,
    } = this.props

    if (!slug) return null

    return (
      <InfiniteScroll load={load} page={Number(loadSectionsFrom)}>
        <ShowcaseLayout
          userId={userId}
          sections={sections.items}
          navigation={navigation.items}
          language={language}
          slug={slug}
          sectionSlug={sectionSlug}
          contentType={contentType}
          app={app}
          dispatch={dispatch}
          areLanguagesMatched={libraryLang === language}
          getShowcasePath={this.getShowcasePath}
          isKids={isKids}
        />
      </InfiniteScroll>
    )
  }
}

export default ShowcaseContent
